import { useCallback, useEffect, useRef } from 'react';
import type { FlatListProps } from 'react-native';
import { bridge, isNotNil } from 'shared/src/utils';
import { AdAction } from 'shared/src/utils/eventLogger/adLogger/types';
import type { GoodsListCardItem } from '../utils/convertGoodsListItemToGoodsData';
import { getGoodsAnalytics } from './getGoodsAnalytics';

type Params = {
  type: string;
  listId: string | undefined;
  listParams: string | undefined;
};

export const useLogDisplayGoods = (params: Params) => {
  const loggedRef = useRef<Set<number>>(new Set());

  // 당일출고 토글 등으로 리스트가 갱신되면 중복 방지 Set 초기화
  useEffect(() => {
    loggedRef.current.clear();
  }, [params.listId, params.listParams]);

  // FlatList는 onViewableItemsChanged를 mount 시점에만 고정하므로
  // 콜백을 안정화하고 최신값은 ref로 참조
  const latestRef = useRef<Params>(params);
  latestRef.current = params;

  return useCallback<
    NonNullable<FlatListProps<GoodsListCardItem>['onViewableItemsChanged']>
  >(({ viewableItems }) => {
    const current = latestRef.current;
    viewableItems.forEach(({ index, isViewable, item }) => {
      if (!isViewable || index == null) return;
      const sno = item.item.sno;
      if (loggedRef.current.has(sno)) return;
      loggedRef.current.add(sno);

      bridge.logAnalyticsEvent({
        name: 'DISPLAY_GOODS',
        analytics: getGoodsAnalytics(item, index, current),
      });
      if (isNotNil(item.item.ad)) {
        bridge.logAdEvent({ action: AdAction.DISPLAY, ad: item.item.ad });
      }
    });
  }, []);
};
